import React from 'react';
import { Link } from 'react-router-dom';
import { CSVLink } from 'react-csv';

import Summary from './Summary';
import Samples from './Samples';
import Pagination from './Pagination';
import TableInfo from './TableInfo';

class Main extends React.Component {
  constructor(props) {
    super(props);

    const { focusData } = props;

    this.state = {
      focusData: [...focusData],
      pageList: [...focusData],
      filteredList: [],
      filteredListRegion: [],
      pageOfItems: [],
      openRows: [],
      filterOpen: false,
      filterList: [
        { name: 'eHRAF World Cultures', key: 'ehraf' },
        { name: 'Standard Cross-Cultural Sample', key: 'sccs' },
        { name: 'Ethnographic Atlas', key: 'ea' },
        { name: 'Ethnographic Atlas Summary', key: 'easum' },
        { name: 'Atlas of World Cultures', key: 'awc' },
        { name: 'Simple Random Sample (HRAF)', key: 'srs' },
        { name: 'Probability Sample Files (HRAF)', key: 'psf' },
        { name: 'Standard Ethnographic Sample', key: 'ses' },
        { name: 'World Ethnographic Sample', key: 'wes' },
        { name: 'HRAF Fiche', key: 'fiche' }
      ],
      selectedFilters: [],
      searchCulture: '',
      perPage: '10',
      regionFilter: 'all',
      showTableInfo: false,
      showEthnonyms: false
    };
  }

  componentDidUpdate(pp, ps) {
    if (ps.searchCulture !== this.state.searchCulture) {
      let searchList =
        this.state.filteredList.length > 0
          ? [...this.state.filteredList]
          : [...this.state.focusData];

      if (this.state.regionFilter !== 'all') {
        searchList = searchList.filter(
          fdata => fdata.region_code.toLowerCase() === this.state.regionFilter
        );
      }

      if (this.state.searchCulture === '') {
        this.setState({
          pageList: [...searchList]
        });
      } else {
        this.setState({
          pageList: this.searchCultures(searchList)
        });
      }
    }

    if (ps.regionFilter !== this.state.regionFilter) {
      let searchList =
        this.state.filteredList.length > 0
          ? [...this.state.filteredList]
          : [...this.state.focusData];

      if (this.state.searchCulture !== '') {
        searchList = this.searchCultures(searchList)
      }

      if (this.state.regionFilter === 'all') {
        this.setState({
          pageList: [...searchList],
          filteredListRegion: []
        });
      } else {
        let tempList = searchList.filter(
          fdata => fdata.region_code.toLowerCase() === this.state.regionFilter
        );

        this.setState({
          pageList: [...tempList],
          filteredListRegion: [...tempList]
        });
      }
    }

    if (ps.selectedFilters !== this.state.selectedFilters) {
      this.onFilterApply();
    }
  }

  showTableInfo = () => {
    this.setState({ showTableInfo: true });
  };

  hideTableInfo = () => {
    this.setState({ showTableInfo: false });
  };

  onChangeSearch = e => {
    this.setState({
      [e.target.name]: e.target.value
    });
  };

  onClickClearSearch = elementName => {
    this.setState({
      [elementName]: ''
    });
  };

  onChangePage = pageOfItems => {
    // update state with new page of items
    this.setState({ pageOfItems: pageOfItems });
  };

  onClickRow = index => {
    if (this.state.openRows.includes(index)) {
      this.setState({
        openRows: this.state.openRows.filter(row => row !== index)
      });
    } else {
      this.setState({
        openRows: [...this.state.openRows, index]
      });
    }
  };

  onClickSample = index => {
    if (this.state.openSamples.includes(index)) {
      this.setState({
        openSamples: this.state.openSamples.filter(sample => sample !== index)
      });
    } else {
      this.setState({
        openSamples: [...this.state.openSamples, index]
      });
    }
  };

  onClickFilter = () => {
    this.setState({
      filterOpen: !this.state.filterOpen
    });
  };

  onClickFilterButton = key => {
    if (this.state.selectedFilters.includes(key)) {
      this.setState({
        selectedFilters: this.state.selectedFilters.filter(
          btnkey => btnkey !== key
        )
      });
    } else {
      this.setState({
        selectedFilters: [...this.state.selectedFilters, key]
      });
    }
  };

  onFilterApply = () => {
    let filteredList = [...this.state.focusData];

    if (this.state.selectedFilters.includes('ehraf')) {
      filteredList = filteredList.filter(fdata => fdata.ehraf);
    }

    if (this.state.selectedFilters.includes('sccs')) {
      filteredList = filteredList.filter(fdata => fdata.sccs);
    }

    if (this.state.selectedFilters.includes('ea')) {
      filteredList = filteredList.filter(fdata => fdata.ea);
    }

    if (this.state.selectedFilters.includes('easum')) {
      filteredList = filteredList.filter(fdata => fdata.ea_sum);
    }

    if (this.state.selectedFilters.includes('awc')) {
      filteredList = filteredList.filter(fdata => fdata.awc);
    }

    if (this.state.selectedFilters.includes('srs')) {
      filteredList = filteredList.filter(fdata => fdata.srs);
    }

    if (this.state.selectedFilters.includes('psf')) {
      filteredList = filteredList.filter(fdata => fdata.psf);
    }

    if (this.state.selectedFilters.includes('ses')) {
      filteredList = filteredList.filter(fdata => fdata.ses);
    }

    if (this.state.selectedFilters.includes('wes')) {
      filteredList = filteredList.filter(fdata => fdata.wes);
    }

    if (this.state.selectedFilters.includes('fiche')) {
      filteredList = filteredList.filter(fdata => fdata.fiche);
    }

    let tempPageList =
      this.state.filteredListRegion.length > 0
        ? filteredList.filter(
            fdata => fdata.region_code.toLowerCase() === this.state.regionFilter
          )
        : filteredList;

    tempPageList =
      this.state.searchCulture !== ''
        ? this.searchCultures(tempPageList)
        : tempPageList;

    if (this.state.selectedFilters.length === 0) {
      this.setState({
        pageList: [...tempPageList],
        filteredList: [],
        openRows: [],
        openSamples: []
      });
    } else {
      this.setState({
        pageList: [...tempPageList],
        filteredList: [...filteredList],
        openRows: [],
        openSamples: []
      });
    }
  };

  onClickClearFilter = () => {
    this.setState({
      pageList: [...this.state.focusData],
      filteredList: [],
      filteredListRegion: [],
      selectedFilters: [],
      filterOpen: false,
      openRows: [],
      openSamples: [],
      searchCulture: '',
      regionFilter: 'all'
    });
  };

  onClickClearSamplesFilter = () => {
    this.setState({
      selectedFilters: []
    });
  };

  onClickEthnonymsButton = () => {
    this.setState(prevState => ({
      showEthnonyms: !prevState.showEthnonyms
    }))
  }

  padZero = (number, length) => {
    let myString = '' + number;
    while (myString.length < length) {
      myString = '0' + myString;
    }

    return myString;
  };

searchCultures = (searchList) => {
    return searchList.filter(fdata => fdata.culture_name.toLowerCase().includes(this.state.searchCulture.toLowerCase()) || fdata.ethnonyms.some(ethnonym => ethnonym.toLowerCase().includes(this.state.searchCulture.toLowerCase())))
  }

  exportCsvData = exportData => {
    let tempData = [...exportData];

    let record_field_names = [
      'Culture Name',
      'Start Date',
      'End Date',
      'Community Name',
      'District Name',
      'Focus Note',
      'Region Code',
      'Culture Area',
      'Countries',
      'Population (in thousands)',
      'Population Year',
      'Population Note',
      'Language Name',
      'Language Code',
      'Language Note',
      'Ethnonyms'
    ];

    let sccs_field_names = ['SCCS ID', 'SCCS Name', 'SCCS Date', 'SCCS Note'];

    let ea_field_names = ['EA ID', 'EA Name', 'EA Date', 'EA Note'];

    let ea_sum_field_names = [
      'EA Summary ID',
      'EA Summary Name',
      'EA Summary Date',
      'EA Summary Note'
    ];

    let awc_field_names = ['AWC ID', 'AWC Name', 'AWC Date', 'AWC Note'];

    let srs_field_names = ['SRS'];

    let psf_field_names = ['PSF Cluster No', 'PSF Cluster Name'];

    let ses_field_names = ['SES Name'];

    let wes_field_names = ['WES Name'];

    let fiche_field_names = [
      'Fiche ID',
      'Fiche Name',
      'Fiche Source',
      'Fiche Note'
    ];

    let ehraf_field_names = ['eHRAF ID', 'eHRAF Name', 'eHRAF Source'];

    let finalData2 = [[...record_field_names]];

    if (this.state.selectedFilters.length === 0) {
      finalData2 = [
        [
          ...sccs_field_names,
          ...ea_field_names,
          ...ea_sum_field_names,
          ...awc_field_names,
          ...srs_field_names,
          ...psf_field_names,
          ...ses_field_names,
          ...wes_field_names,
          ...fiche_field_names,
          ...ehraf_field_names,
          ...finalData2[0]
        ]
      ];
    } else {
      if (this.state.selectedFilters.includes('sccs')) {
        finalData2 = [[...sccs_field_names, ...finalData2[0]]];
      }

      if (this.state.selectedFilters.includes('ea')) {
        finalData2 = [[...ea_field_names, ...finalData2[0]]];
      }

      if (this.state.selectedFilters.includes('easum')) {
        finalData2 = [[...ea_sum_field_names, ...finalData2[0]]];
      }

      if (this.state.selectedFilters.includes('awc')) {
        finalData2 = [[...awc_field_names, ...finalData2[0]]];
      }

      if (this.state.selectedFilters.includes('srs')) {
        finalData2 = [[...srs_field_names, ...finalData2[0]]];
      }

      if (this.state.selectedFilters.includes('psf')) {
        finalData2 = [[...psf_field_names, ...finalData2[0]]];
      }

      if (this.state.selectedFilters.includes('ses')) {
        finalData2 = [[...ses_field_names, ...finalData2[0]]];
      }

      if (this.state.selectedFilters.includes('wes')) {
        finalData2 = [[...wes_field_names, ...finalData2[0]]];
      }

      if (this.state.selectedFilters.includes('fiche')) {
        finalData2 = [[...fiche_field_names, ...finalData2[0]]];
      }

      if (this.state.selectedFilters.includes('ehraf')) {
        finalData2 = [[...ehraf_field_names, ...finalData2[0]]];
      }
    }

    tempData.forEach(fdata => {
      let record_field_data = [
        fdata.culture_name,
        fdata.start_date,
        fdata.end_date,
        fdata.community_name,
        fdata.district_name,
        fdata.focus_note,
        fdata.region_code,
        fdata.culture_area,
        fdata.countries,
        fdata.population,
        fdata.population_year,
        fdata.population_note,
        fdata.lang_name,
        fdata.lang_code,
        fdata.lang_note,
        fdata.ethnonyms
      ];

      let sccs_field_data = [
        fdata.sccs ? fdata.sccs.id : 'None',
        fdata.sccs ? fdata.sccs.name : 'None',
        fdata.sccs ? fdata.sccs.date : 'None',
        fdata.sccs ? fdata.sccs.note : 'None'
      ];

      let ea_field_data = [
        fdata.ea ? fdata.ea.id : 'None',
        fdata.ea ? fdata.ea.name : 'None',
        fdata.ea ? fdata.ea.date : 'None',
        fdata.ea ? fdata.ea.note : 'None'
      ];

      let ea_sum_field_data = [
        fdata.ea_sum ? fdata.ea_sum.id : 'None',
        fdata.ea_sum ? fdata.ea_sum.name : 'None',
        fdata.ea_sum ? fdata.ea_sum.date : 'None',
        fdata.ea_sum ? fdata.ea_sum.note : 'None'
      ];

      let awc_field_data = [
        fdata.awc ? fdata.awc.id : 'None',
        fdata.awc ? fdata.awc.name : 'None',
        fdata.awc ? fdata.awc.date : 'None',
        fdata.awc ? fdata.awc.note : 'None'
      ];

      let srs_field_data = [fdata.srs ? '1' : '0'];

      let psf_field_data = [
        fdata.psf ? fdata.psf.cluster_no : 'None',
        fdata.psf ? fdata.psf.cluster_name : 'None'
      ];

      let ses_field_data = [fdata.ses ? fdata.ses.name : 'None'];

      let wes_field_data = [fdata.wes ? fdata.wes.name : 'None'];

      let fiche_field_data = [
        fdata.fiche ? fdata.fiche.id : 'None',
        fdata.fiche ? fdata.fiche.name : 'None',
        fdata.fiche ? fdata.fiche.source : 'None',
        fdata.fiche ? fdata.fiche.note : 'None'
      ];

      let ehraf_docs = '';

      fdata.ehraf &&
        fdata.ehraf_docs.forEach(doc => {
            ehraf_docs = ehraf_docs + `http://ehrafworldcultures.yale.edu/document?id=${doc.owc.toLowerCase()}-${doc.document_no.padStart(3, '0')}`;
            if (doc.coverage !== 'entire') {
              ehraf_docs = ehraf_docs + ' (' + doc.coverage + ')\n';
            } else {
              ehraf_docs = ehraf_docs + "\n"
            }
        });

      let ehraf_field_data = [
        fdata.ehraf ? fdata.ehraf.id : 'None',
        fdata.ehraf ? fdata.ehraf.name : 'None',
        fdata.ehraf ? ehraf_docs : 'None'
      ];

      let tempArrayRecord = [...record_field_data];

      if (this.state.selectedFilters.length === 0) {
        tempArrayRecord = [
          ...sccs_field_data,
          ...ea_field_data,
          ...ea_sum_field_data,
          ...awc_field_data,
          ...srs_field_data,
          ...psf_field_data,
          ...ses_field_data,
          ...wes_field_data,
          ...fiche_field_data,
          ...ehraf_field_data,
          ...tempArrayRecord
        ];
      } else {
        if (this.state.selectedFilters.includes('sccs')) {
          tempArrayRecord = [...sccs_field_data, ...tempArrayRecord];
        }

        if (this.state.selectedFilters.includes('ea')) {
          tempArrayRecord = [...ea_field_data, ...tempArrayRecord];
        }

        if (this.state.selectedFilters.includes('easum')) {
          tempArrayRecord = [...ea_sum_field_data, ...tempArrayRecord];
        }

        if (this.state.selectedFilters.includes('awc')) {
          tempArrayRecord = [...awc_field_data, ...tempArrayRecord];
        }

        if (this.state.selectedFilters.includes('srs')) {
          tempArrayRecord = [...srs_field_data, ...tempArrayRecord];
        }

        if (this.state.selectedFilters.includes('psf')) {
          tempArrayRecord = [...psf_field_data, ...tempArrayRecord];
        }

        if (this.state.selectedFilters.includes('ses')) {
          tempArrayRecord = [...ses_field_data, ...tempArrayRecord];
        }

        if (this.state.selectedFilters.includes('wes')) {
          tempArrayRecord = [...wes_field_data, ...tempArrayRecord];
        }

        if (this.state.selectedFilters.includes('fiche')) {
          tempArrayRecord = [...fiche_field_data, ...tempArrayRecord];
        }

        if (this.state.selectedFilters.includes('ehraf')) {
          tempArrayRecord = [...ehraf_field_data, ...tempArrayRecord];
        }
      }

      finalData2.push(tempArrayRecord);
    });

    return finalData2;
  };

  render() {
    return (
      <div className='ui container'>
        <div
          className={
            this.state.selectedFilters.length !== 0 ||
            this.state.regionFilter !== 'all' ||
            this.state.searchCulture !== ''
              ? ''
              : 'hide-element'
          }
        >
          <div
            className='ui blue aligned right button middle aligned'
            onClick={() => this.onClickClearFilter()}
            disabled={this.state.selectedFilters.length === 0}
          >
            Clear All Filters
          </div>
        </div>
        <div className='ui horizontal stackable segments filters'>
          <div
            onClick={() => this.onClickFilter()}
            className='ui segment labeled icon top right pointing dropdown button'
          >
            <i className='filter icon'></i>
            <span className='text'>
              Filter Samples{' '}
              {this.state.selectedFilters.length !== 0 &&
                `(${this.state.selectedFilters.length} Selected)`}
            </span>
          </div>

          <select
            value={this.state.regionFilter}
            name='regionFilter'
            className='ui segment simple dropdown item middle aligned'
            onChange={this.onChangeSearch}
          >
            <option value='all'>All Regions</option>
            <option value='af'>Africa</option>
            <option value='as'>Asia</option>
            <option value='eu'>Europe</option>
            <option value='me'>Middle East</option>
            <option value='na'>North America</option>
            <option value='oc'>Ocenia</option>
            <option value='sa'>South America</option>
          </select>

          <input
            className='ui segment input prompt'
            type='text'
            placeholder='Search Culture Name...'
            name='searchCulture'
            value={this.state.searchCulture}
            onChange={this.onChangeSearch}
          />

          <select
            value={this.state.perPage}
            name='perPage'
            className='ui segment simple dropdown item middle aligned'
            onChange={this.onChangeSearch}
          >
            <option value='10'>10 records</option>
            <option value='25'>25 records</option>
            <option value='50'>50 records</option>
          </select>
          <button id="ethnonymsButton" onClick={this.onClickEthnonymsButton}>{this.state.showEthnonyms ? "Hide Ethnonyms" : "Display Ethnonyms"}</button>
        </div>

        <div className={this.state.filterOpen ? '' : 'hide-element'}>
          <div className='ui raised segment'>
            {this.state.filterList.map(filterElement => (
              <button
                key={filterElement.key}
                className='ui button'
                onClick={() => this.onClickFilterButton(filterElement.key)}
              >
                {this.state.selectedFilters.includes(filterElement.key) && (
                  <i className='check icon'></i>
                )}{' '}
                {filterElement.name}
              </button>
            ))}
            <div className='ui divider'></div>
            <button
              className='ui blue aligned right button'
              onClick={() => this.onClickClearSamplesFilter()}
              disabled={this.state.selectedFilters.length === 0}
            >
              Clear Samples Filter
            </button>
            <button
              className='ui red aligned right button'
              onClick={() => this.onClickFilter()}
            >
              Close
            </button>
          </div>
        </div>

        <div className='div-table-section'>
          <table className='ui unstackable table'>
            <thead>
              <tr>
                <th>Culture Name</th>
                <th className={this.state.showEthnonyms ? "" : "hide-element"}>Ethnonyms</th>
                <th>Time</th>
                <th>Specific Sub-Cultural Focus</th>
                <th>Profile Link</th>
              </tr>
            </thead>
            <tbody>
              {this.state.pageOfItems.map((fdata, index) => (
                <React.Fragment key={`${fdata.focusID}-${index}`}>
                  <tr
                    className='table-main-row'
                    onClick={() => this.onClickRow(`${fdata.focusID}-${index}`)}
                  >
                    <td>
                      {this.state.openRows.includes(
                        `${fdata.focusID}-${index}`
                      ) ? (
                        <i className='chevron down icon'></i>
                      ) : (
                        <i className='chevron right icon'></i>
                      )}{' '}
                      {fdata.culture_name}
                    </td>
                    <td className={this.state.showEthnonyms ? "" : "hide-element"} style={{width:"20%"}}>
                      {fdata.ethnonyms.length === 0 ? "None": fdata.ethnonyms.join(", ")}
                    </td>
                    <td>
                      {fdata.start_date === 9999 || fdata.start_date === 8888
                        ? 'Not Specified'
                        : fdata.start_date === fdata.end_date
                        ? fdata.start_date
                        : `${fdata.start_date}-${fdata.end_date}`}
                    </td>
                    <td>
                      {fdata.community_name === 'None'
                        ? fdata.district_name === 'None'
                          ? fdata.focus_note === 'None'
                            ? 'Not Specified'
                            : fdata.focus_note
                          : fdata.district_name
                        : fdata.community_name}
                    </td>
                    <td>
                      <Link to={`/profile/${fdata.focusID}`}>
                        <button className='circular ui icon button'>
                          <i className='icon globe'></i>
                        </button>
                      </Link>
                    </td>
                  </tr>
                  <tr
                    className={
                      this.state.openRows.includes(`${fdata.focusID}-${index}`)
                        ? ''
                        : 'hide-element'
                    }
                  >
                    <td colSpan='4'>
                      <Summary fdata={fdata} />
                      <Samples fdata={fdata} index={index} />
                    </td>
                  </tr>
                </React.Fragment>
              ))}
            </tbody>
            <tfoot>
              <tr>
                <th colSpan='4'>
                  <CSVLink
                    className='ui button green'
                    filename={'ehraf-ccr.csv'}
                    data={this.exportCsvData(this.state.pageList)}
                  >
                    Export
                  </CSVLink>

                  <button
                    className='circular ui icon button'
                    onClick={this.showTableInfo}
                  >
                    <i className='question icon'></i>
                  </button>

                  <Pagination
                    items={this.state.pageList}
                    onChangePage={this.onChangePage}
                    initialPage={1}
                    perPage={parseInt(this.state.perPage)}
                  />
                </th>
              </tr>
            </tfoot>
          </table>
        </div>

        <div className={this.state.showTableInfo ? '' : 'hide-element'}>
          <div className='modal'>
            <TableInfo handleClose={this.hideTableInfo} />
          </div>
        </div>
      </div>
    );
  }
}

export default Main;
